<template>
  <div class="home_vue_comp">
    <!-- *RPD MHOR  Appv 0.91
* Copyright (c) 2025, Blue Cover Six LLC . John Molt. All rights reserved.
Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->
    <auth></auth>
    <v-btn
      @click="addreg"
      v-if="show_admin"
      style="top: 80dvh"
      color="grey darken-1"
      dark
      fixed
      top
      right
      fab
    >
      <v-icon color="white">$plus</v-icon>
    </v-btn>
    <v-main>
      <v-container fluid id="home-container" class="mt-9">
        <div
          id="home-form"
          v-show="show_home_form"
          class="mtd-flex flex-column"
        >
          <v-btn
            dark
            v-if="admin && show_edit_label == false"
            @click="show_admin_now"
            class="grey darken-1"
            >Show Admin</v-btn
          >

          <add_edit
            :current_edit="current_edit"
            :show_edit_label="show_edit_label"
            @update="update"
            @cancel_edit="cancel_edit"
          ></add_edit>
        </div>
        <div id="admin-cntnr" v-if="show_admin">
          <template>
            <v-expansion-panels dark v-model="panel" @click.stop>
              <v-expansion-panel>
                <v-expansion-panel-header class="grey darken-2" @click.stop>
                  Search
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <search
                    @search_done="search_done"
                    :update_search="update_search"
                  ></search>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel class="mt-3" v-if="lst_srch_res.length > 0">
                <v-expansion-panel-header class="grey darken-2" @click.stop>
                  Search Results</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <search_results
                    :lst_srch_res="lst_srch_res"
                    @edit_srch="edit_srch"
                    @del="del"
                  ></search_results>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel class="mt-3">
                <v-expansion-panel-header class="grey darken-2" @click.stop>
                  Recents
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <recents
                    @edit_in="edit_in"
                    @del="del"
                    :update_recents="update_recents"
                  ></recents>
                </v-expansion-panel-content>
              </v-expansion-panel>
                            <v-expansion-panel class="mt-3">
                <v-expansion-panel-header class="grey darken-2" @click.stop>
                  Archived
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <archived
                    @unarchive="unarchive"
                    :update_archived="update_archived"
                  ></archived>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </div>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
/* Remove the default padding inside expansion panel content */
.v-expansion-panel-content__wrap {
  background-color: red;
  padding: 0 !important;
}

@media (min-width: 0px) {
  #home-container {
    height: auto;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .section1 {
    justify-content: center;
    width: 100%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

import add_edit from "./add_edit.vue";
const recents = () => import("./recents.vue");
const archived = () => import("./archived.vue");
const search = () => import("./search.vue");
const search_results = () => import("./search_results.vue");
import auth from "./auth.vue";

export default {
  name: "Home",
  components: { add_edit, recents, archived, search, search_results, auth },
  mixins: [bus_common],
  data() {
    return {
      update_search: null,
      update_recents: null,
      update_archived: null,
      mode: "edit",
      show_edit_label: false,
      lst_regs: [],
      lst_srch_res: [],
      current_edit: null,
      panel: 1,
      show_admin: false,
      show_home_form: true,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },
  computed: {
    admin: function () {
      return this.$store.state.user.roles.indexOf("mhor-admin") > -1;
    },
  },
  methods: {

unarchive(reg) {
  console.log("unarchive");
  this.show_loader(true);

  var formIn = {};
  formIn.email = this.$store.state.user.email;
  formIn.token = this.$store.state.user.token;
  formIn.registrationId = reg.registrationId;
  formIn.apiname = "unarchive";

  var self = this;

  this.$store
    .dispatch("anyapi", formIn)
    .then((data) => {
      console.log("unarchive api success", data);

      try {
        this.show_loader(false);

        this.swall_it("Record Status", "Unarchived", "success", null, null);
        this.cancel_edit();
        this.init();
      } catch (err) {

        this.show_loader(false);

        let errMsg =
          err && err.message
            ? err.message
            : JSON.stringify(err, Object.getOwnPropertyNames(err));

        this.swall_it("Error Unarchive Post-Step", errMsg, "error", null, null);
      }
    })
    .catch((err) => {
      console.error("Unarchive API / promise error:", err);
      self.dialog = false;
      this.show_loader(false);

      let errMsg = "Unknown error";

      if (err) {
        if (err.msg) {
          errMsg = err.msg;
        } else if (err.message) {
          errMsg = err.message;
        } else {
          try {
            errMsg = JSON.stringify(err, Object.getOwnPropertyNames(err));
          } catch (jsonErr) {
            errMsg = String(err);
          }
        }
      }

      this.swall_it("Error Unarchived", errMsg, "error", null, null);
    });
},


    del(reg) {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.registrationId = reg.registrationId;

      formIn.apiname = "delete";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data.msg.indexOf("found") > -1) {
            this.swall_it(
              "Delete Status",
              "Not Deleted. Uknown error.",
              "error",
              null,
              null
            );
          }
          self.update_search = new Date();
          self.update_recents = new Date();
          this.swall_it("Delete Status", "Deleted.", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error search", msg.msg, "error", null, null);
        });
    },
    cancel_edit() {
      console.log("cancel edit admin false");
      var self = this;

      this.show_edit_label = false;
      this.current_edit = null;
      this.show_admin = true;
      this.show_home_form = false;

      console.log("mode " + this.mode);
      if (this.mode == "srch") {
        setTimeout(() => {
          self.panel = 1;
          document.getElementById("vapp").scrollTop = 0;
          this.mode = "";
        }, 250);
        return true;
      }
      if (this.mode == "edit") {
        setTimeout(() => {
          self.panel = 1;
          document.getElementById("vapp").scrollTop = 0;
          this.mode = "";
        }, 250);
        return true;
      }
    },
    search_done(data) {
      this.lst_srch_res = this.mno(data);
      setTimeout(() => {
         this.panel = 3;
      }, 500);
     
    },
      update(data) {
        if (this.mode == "edit") {
          this.show_edit_label = false;
          this.current_edit = null;
          this.show_home_form = false;
          this.show_admin = true;

          this.update_recents = new Date();   // force recents refresh
          this.update_search = new Date();    // optional, if search results also need refresh

          setTimeout(() => {
            document.getElementById("vapp").scrollTop = 0;
          }, 250);
        }
      },
    edit_srch(reg) {
      this.mode = "srch";
      this.show_edit_label = true;
      this.current_edit = reg;
      console.log("edit search admin false");
      this.show_admin = false;
      this.show_home_form = true;
      setTimeout(() => {
        document.getElementById("vapp").scrollTop = 0;
      }, 250);
    },
      edit_in(reg) {
        this.mode = "edit";
        this.show_edit_label = true;
        this.current_edit = this.mno(reg);   // clone, do not share live object
        this.show_admin = false;
        this.show_home_form = true;

        setTimeout(() => {
          document.getElementById("vapp").scrollTop = 0;
        }, 250);
      },
    addreg() {
      this.mode = "edit";
      this.show_edit_label = true;
      this.current_edit = null;
      console.log("add_regadmin false");

      this.show_admin = false;
      this.show_home_form = true;
      setTimeout(() => {
        document.getElementById("vapp").scrollTop = 0;
      }, 250);
    },
    show_form_now(payload) {
      console.log("[show_form_now] payload:", payload);
      console.trace("[show_form_now] call stack");
      this.mrbreakpoint("arg fuck");
      this.current_edit = null;
      this.show_home_form = true;
      console.log("show from now admin false");
      this.show_admin = false;
    },
    show_admin_now() {
      this.show_home_form = false;
      this.show_admin = true;
      this.panel = 1;
    },
    reg_fetch(id) {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.id = this.id;

      formIn.apiname = "reg_fetch";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {})
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error search", msg.msg, "error", null, null);
        });
    },
    reg_fetch(id) {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.id = id;

      formIn.apiname = "reg_fetch";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.current_edit = this.mno(data);
          self.show_loader(false);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error search", msg.msg, "error", null, null);
        });
    },

    init(self) {
      this.update_recents = Date();
        this.update_archived = Date();
      this.current_edit = null;
      this.show_loader(false);
      // chek for query string

      setTimeout(() => {
        const id = this.$route.query?.id || null;
        if (id != null) {
          this.reg_fetch(id);
        }
      }, 500);
    },
  },
  mounted() {
    // fake user login
    // var user = {
    //   email: "jvonmolt@gmail.com",
    //   roles: "mhor-admin",
    //   token: "myverylongandencryptedtoken",
    //   rpduserId: 42,
    //   auth: true,
    // };
    // this.$store.commit("setUser", user);
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
